import { useTranslation } from 'react-i18next';

import { terms } from '../utils/translation/i18n_terms';

export const useTypedTranslation = () => {
  const orig = useTranslation();
  return { ...orig, terms };
};
